import * as React from 'react';
import { NewModal } from 'lib/components';
import { MdDeleteForever } from 'react-icons/md';

import { ListWebsiteOverlay } from 'lib/api';
import { Button, Typography } from 'react-covideo-common';
import { Flex } from '../styles/layout';
import { Trans, useTranslation } from 'react-i18next';

interface Props {
  onClose: (params?: any) => void;
  onDelete: (params?: any) => void;
  data: ListWebsiteOverlay;
  modalLoading: boolean;
}

export const ModalDeleteWebsiteOverlay = (props: Props) => {
  const { data, onClose, onDelete, modalLoading } = props;
  const { t } = useTranslation();
  return (
    <NewModal
      closeModal={onClose}
      headerText={t('Delete Website Overlay URL?')}
    >
      <Flex flexDirection='column' gap='16px' margin='0 0 16px 0'>
        <Typography variant='small'>
          <Trans
            i18nKey='areYouSureYouWantToDeleteTheUrl'
            values={{ title: data.title }}
            components={{
              bold: <Typography variant='small' as='span' fontWeight={800} />,
            }}
          />
        </Typography>
        <Typography variant='small'>
          {t("This action can't be undone.")}
        </Typography>
      </Flex>
      <Flex
        justifyContent={'flex-end'}
        width='100%'
        gap='12px'
        flexDirection='row'
      >
        <Button
          text={t('Cancel')}
          onClick={() => onClose()}
          disabled={modalLoading}
          variant='secondary'
        />
        <Button
          icon={<MdDeleteForever />}
          text={t('Yes, Delete')}
          onClick={() => onDelete(data.id)}
          variant='destructive'
          disabled={modalLoading}
        />
      </Flex>
    </NewModal>
  );
};
